/**
 * Плитка быстрого действия: иконка, название и подсказка.
 *
 * Плитка целиком — кнопка: по маленькой иконке на телефоне не попасть.
 */
import type { ReactNode } from 'react';

import { Icon, type IconName } from './Icon';
import styles from './ActionTile.module.css';

export function ActionGrid({ children }: { children: ReactNode }) {
  return <div className={styles.grid}>{children}</div>;
}

export function ActionTile({
  icon,
  title,
  hint,
  onClick,
  disabled = false,
}: {
  icon: IconName;
  title: string;
  hint: string;
  onClick: () => void;
  disabled?: boolean;
}) {
  return (
    <button type="button" className={styles.tile} onClick={onClick} disabled={disabled}>
      <span className={styles.icon}>
        <Icon name={icon} size={19} />
      </span>
      <span className={styles.title}>{title}</span>
      <span className={styles.hint}>{hint}</span>
    </button>
  );
}
